import React, { createContext, useContext, useState, useEffect } from 'react';
import { useSiteConfig } from '../hooks/useSupabase';

const SiteContext = createContext();

export const useSite = () => useContext(SiteContext);

export const SiteProvider = ({ children }) => {
  const { data: siteConfigData, loading: configLoading, error: configError } = useSiteConfig();
  const [siteConfig, setSiteConfig] = useState({
    logo_url: '',
    primary_color: '#1d4ed8',
    secondary_color: '#1e293b',
    site_name: 'Α.Ο. Χανιά',
    site_description: 'Γυναικεία Ομάδα Ποδοσφαίρου',
    social_facebook: 'https://www.facebook.com/aoxaniawfc',
    social_instagram: 'https://www.instagram.com/aoxaniawfc',
    social_youtube: 'https://www.youtube.com/@AOXaniawfc',
    phone: '6976988860 , 6974078106',
    email: 'aoxaniawoman@gmail.com',
    address: 'Δημοτικό Γήπεδο Μοναχής Ελιάς, Χανιά',
    stats_founding_year: '1945',
    stats_players_count: '20+',
    stats_league_division: 'Γ\'',
    stats_years_history: '80',
    footer_about_text: 'Από το 1945, ο Α.Ο. Χανιά συνεχίζει την παράδοση στο ποδόσφαιρο. Η γυναικεία μας ομάδα αγωνίζεται στη Γ\' Εθνική Κατηγορία με στόχο την προώθηση του γυναικείου ποδοσφαίρου στην Κρήτη.',
    team_history_text: 'Ο Α.Ο. Χανιά ιδρύθηκε το 1945 και αποτελεί έναν από τους παλαιότερους συλλόγους της Κρήτης. Μέχρι το 2017, ο σύλλογος διατηρούσε και ανδρική ομάδα. Από τότε, συνεχίζει αποκλειστικά με τη γυναικεία του ομάδα, η οποία αγωνίζεται στη Γ\' Εθνική Κατηγορία. Η ομάδα έχει ως στόχο την προώθηση του γυναικείου ποδοσφαίρου στην περιοχή και την ανάδειξη νέων ταλέντων.',
    academy_banner_image: '',
    show_k17_carousel: true,
    show_k15_carousel: true,
    show_k13_carousel: true,
    matchday_mode_enabled: true,
    matchday_window_days: 5,
    matchday_threshold_hours: 24,
    matchday_live_fallback_hours: 3,
    matchday_upcoming_count: 2,
    matchday_selection_mode: 'automatic',
    matchday_manual_match_id: null,
  });

  useEffect(() => {
    if (!configLoading && !configError && siteConfigData?.length > 0) {
      const config = siteConfigData[0];
      setSiteConfig({
        ...config,
        social_facebook: config.social_facebook || 'https://www.facebook.com/aoxaniawfc',
        social_instagram: config.social_instagram || 'https://www.instagram.com/aoxaniawfc',
        social_youtube: config.social_youtube || 'https://www.youtube.com/@AOXaniawfc',
        stats_founding_year: config.stats_founding_year || '1945',
        stats_players_count: config.stats_players_count || '20+',
        stats_league_division: config.stats_league_division || 'Γ\'',
        stats_years_history: config.stats_years_history || '80',
        footer_about_text: config.footer_about_text || 'Από το 1945, ο Α.Ο. Χανιά συνεχίζει την παράδοση στο ποδόσφαιρο. Η γυναικεία μας ομάδα αγωνίζεται στη Γ\' Εθνική Κατηγορία με στόχο την προώθηση του γυναικείου ποδοσφαίρου στην Κρήτη.',
        team_history_text: config.team_history_text || 'Ο Α.Ο. Χανιά ιδρύθηκε το 1945 και αποτελεί έναν από τους παλαιότερους συλλόγους της Κρήτης. Μέχρι το 2017, ο σύλλογος διατηρούσε και ανδρική ομάδα. Από τότε, συνεχίζει αποκλειστικά με τη γυναικεία του ομάδα, η οποία αγωνίζεται στη Γ\' Εθνική Κατηγορία. Η ομάδα έχει ως στόχο την προώθηση του γυναικείου ποδοσφαίρου στην περιοχή και την ανάδειξη νέων ταλέντων.',
        academy_banner_image: config.academy_banner_image || '',
        show_k17_carousel: config.show_k17_carousel !== false,
        show_k15_carousel: config.show_k15_carousel !== false,
        show_k13_carousel: config.show_k13_carousel !== false,
        matchday_mode_enabled: config.matchday_mode_enabled !== false,
        matchday_window_days: Number.isFinite(Number(config.matchday_window_days)) ? Number(config.matchday_window_days) : 5,
        matchday_threshold_hours: Number.isFinite(Number(config.matchday_threshold_hours)) ? Number(config.matchday_threshold_hours) : 24,
        matchday_live_fallback_hours: Number.isFinite(Number(config.matchday_live_fallback_hours)) ? Number(config.matchday_live_fallback_hours) : 3,
        matchday_upcoming_count: Number.isFinite(Number(config.matchday_upcoming_count)) ? Number(config.matchday_upcoming_count) : 2,
        matchday_selection_mode: ['automatic', 'featured', 'manual'].includes(config.matchday_selection_mode) ? config.matchday_selection_mode : 'automatic',
        matchday_manual_match_id: config.matchday_manual_match_id || null,
        phone: config.phone || '6976988860 , 6974078106',
        email: config.email || 'aoxaniawoman@gmail.com',
        address: config.address || 'Δημοτικό Γήπεδο Μοναχής Ελιάς, Χανιά'
      });
    }
  }, [siteConfigData, configLoading, configError]);

  return (
    <SiteContext.Provider value={{ siteConfig, loading: configLoading }}>
      {children}
    </SiteContext.Provider>
  );
};
